var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"info-banner"}},[_c('div',{staticClass:"content"},[_c('h1',[_vm._v(" "+_vm._s(_vm.$t('more_info_question'))+" ")]),_vm._v(" "),_c('router-link',{attrs:{"to":"contact"}},[_c('button',{staticClass:"btn-green"},[_vm._v("\n        "+_vm._s(_vm.$t('more_info'))+"\n      ")])])],1)])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-05394722","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/product/ProductInfoBanner.vue
// module id = null
// module chunks = 